import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import {
  Table,
  Button,
  Popconfirm,
  Empty,
  Pagination,
  Tooltip,
  Alert,
  Modal,
} from "antd";
import ModalProduct from "../../modalProduct";
import DrawerFilter from "./drawerFilter";
import DrawerClassify from "./drawerClassify";
import Loading from "../../../../components/Loading";
import { getProduct, deleteProduct } from "../actions";
import { getProducts as getProductsPisCofins } from "../PisCofins/actions";
import { getProducts, classifySuggestion } from "./actions";
import { exportarProdutos } from "./actions";
import { createLoadingSelector } from "../../../../store/api/selectors";
import {
  maskNcm,
  maskCest,
  dateToEnglish,
  contains,
} from "../../../../helpers/functions";
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

const initialState = {
  sizePage: 50,
  visibleModal: false,
  visibleEdit: false,
  visibleDelete: false,
  visibleClassify: false,
  isEdit: false,
  selectedAll: false,
  selectedRowKeys: [],
  selectedBaseNcm: null,
  selectedClassified: null,
  selectedCurrent: null,
  filter: {
    sCodigoProduto: null,
    sDescricao: null,
    sNcm: null,
    sCest: null,
    sEx: null,
    sEan: null,
    sBaseNcm: 0,
    sClassificacaoFinal: 0,
    sBaseClassificacaoUsuario: 0,
    sClassificado: null,
    sDuplicado: null,
    sPeriodo: null,
    sorter: null,
  },
  dropdown: {
    vazioNcm: false,
    vazioCest: false,
    vazioEX: false,
  },
  filterStr: "",
  isDuplicated: false,
  canEditClassify: true,
};

class GridClassify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      pageNumber: 1,
      paginationStr: "",
      visibleDrawerFilter: false,
      visibleDrawerClassify: false,
      editClassify: false,
      listPeriod: [],
      itemFilter: "",
      extraData: {
        month: null,
        year: null,
        status: null,
      },
      useData: [],
    };

    this.handleReset = this.handleReset.bind(this);
    this.visibleModal = this.visibleModal.bind(this);
    this.visibleActions = this.visibleActions.bind(this);
    this.deleteProduct = this.deleteProduct.bind(this);
  }

  componentDidMount() {
    const {
      props,
      props: { productsIcms },
    } = this;
    const { sizePage, useData } = this.state;

    if (!productsIcms || (productsIcms && !productsIcms.length)) {
      this.setState(
        { paginationStr: `?pageNumber=1&pageSize=${sizePage}&filter=` },
        () => {
          const { filterStr } = this.state;          
          props.getProducts(filterStr);
        }
      );
    } else if (useData !== productsIcms) {
      const tempData =
        productsIcms &&
        productsIcms.map((p) => {
          return {
            ...p,
            Ncm: p.Ncm || "",
            Cest: p.Cest || "",
          };
        });
      this.setState({ useData: tempData });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedRowKeys, selectedAll, filterStr } = this.state;
    const { productsIcms, period, statusError } = this.props;
    const { cnpj } = this.props.match.params;

    if (prevState.selectedRowKeys !== selectedRowKeys) {
      this.visibleActions();
      this.visibleClassify();

      if (
        contains(filterStr, ["sNcm", "sCest"], true) ||
        contains(
          filterStr,
          [
            "sBaseNcm=4",
            "sBaseNcm=5",
            "sBaseNcm=101",
            "sBaseNcm=102",
            "sBaseNcm=103",
          ],
          false
        )
      ) {
        this.setState({ canEditClassify: true });
      }
    }

    if (prevProps.match.params.cnpj !== cnpj) {
      this.handleReset();
    }

    if (prevProps.productsIcms !== productsIcms) {
      const useData =
        productsIcms &&
        productsIcms.map((p) => {
          return {
            ...p,
            Ncm: p.Ncm || "",
            Cest: p.Cest || "",
          };
        });
      this.setState({ useData });

      if (selectedAll) {
        this.onSelect(selectedAll);
      }

      if (!productsIcms && statusError) {
        this.setState({
          extraData: {
            month: null,
            year: null,
            status: null,
          },
        });
        this.props.changeActiveTab("4");
        this.props.getProducts();
      } else {
        this.setState({
          extraData: {
            month: period && period.Mes,
            year: period && period.Ano,
            status: statusError,
          },
        });
      }
    }
  }

  handleReset() {
    this.setState({ ...initialState });
    this.props.getProducts();
  }

  visibleModal = (isEdit) => {
    const { visibleModal, selectedRowKeys } = this.state;

    this.setState(
      {
        visibleModal: !visibleModal,
        isEdit: isEdit,
      },
      async () => {
        if (isEdit) {
          await this.props.getProduct(selectedRowKeys[0]);
        }
      }
    );
  };

  visibleActions() {
    const { selectedRowKeys } = this.state;
    const quantity = selectedRowKeys.length;

    if (!quantity) {
      this.setState({
        visibleEdit: false,
        visibleDelete: false,
      });
    } else if (quantity) {
      this.setState({
        visibleEdit: true,
        visibleDelete: true,
      });

      if (quantity > 1) {
        this.setState({
          visibleEdit: false,
        });
      }
    }
  }

  visibleClassify() {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length > 0) {
      this.setState({ visibleClassify: true });
    } else {
      this.setState({ visibleClassify: false });
    }
  }

  deleteProduct = async () => {
    const { selectedRowKeys, selectedAll, filterStr, extraData } = this.state;

    if (selectedAll) {
      await this.props.deleteProduct(
        null,
        extraData,
        filterStr ? `?filter=${filterStr}&todos=true` : "?todos=true"
      );
      this.handleReset();
    } else {
      await this.props.deleteProduct(selectedRowKeys, extraData, "");
      this.handleFilters(true);
    }
  }

  classifySuggestion = async () => {
    const { filterStr, selectedAll, selectedRowKeys, extraData } = this.state;
    let data = {};

    if (!selectedAll) {
      data.Ids = selectedRowKeys;
      await this.props.classifySuggestion(data, `?filter=${filterStr}`, extraData);
    } else {
      await this.props.classifySuggestion(
        data,
        filterStr ? `?filter=${filterStr}&todos=true` : "?todos=true",
        extraData
      );
    }

    this.handleFilters();
  };

  changePage = (page) => {
    const { filterStr, sizePage, extraData, isDuplicated } = this.state;

    this.setState(
      {
        paginationStr: `?pageNumber=${page}&pageSize=${sizePage}&filter=${filterStr}`,
        pageNumber: page,
      },
      () => {        
        this.props.getProducts(
          this.state.paginationStr,
          extraData,
          isDuplicated
        );
      }
    );
  };

  changeSizePage = (current, size) => {
    const { filterStr, extraData } = this.state;

    this.setState(
      {
        sizePage: size,
        paginationStr: `?pageNumber=${current}&pageSize=${size}&filter=${filterStr}`,
      },
      () => {
        this.props.getProducts(this.state.paginationStr, extraData);
      }
    );
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    const { cnpj } = this.props.match.params;
    const { filterStr } = this.state;
    const { sNcm, sCest } = this.state.filter;
    let canEditClassify = this.state.canEditClassify;
    let ncmNaoEncontrada = false;
    let ncm = "";
    let cest = "";

    if (selectedRows.length) {
      ncmNaoEncontrada = _.every(selectedRows, {
        DescricaoTributacaoIcms: "NCM NÃO ENCONTRADA",
      });

      if (!ncmNaoEncontrada) {
        if (
          contains(
            filterStr,
            [
              "sBaseNcm=4",
              "sBaseNcm=5",
              "sBaseNcm=101",
              "sBaseNcm=102",
              "sBaseNcm=103",
            ],
            false
          )
        ) {
          canEditClassify = true;
        } else {
          canEditClassify = _.every(selectedRows, {
            Ncm: selectedRows[0].Ncm,
            Cest: selectedRows[0].Cest,
          });
        }
      }

      this.setState({
        itemFilter: `Ncm=${selectedRows[0].Ncm}&Cest=${selectedRows[0].Cest}&Cnpj=${cnpj}`,
      });
    }

    if (sNcm) ncm = sNcm.replace("=", "");
    if (sCest) cest = sCest.replace("=", "");

    if (ncm || cest) {
      this.setState({ itemFilter: `Ncm=${ncm}&Cest=${cest}&Cnpj=${cnpj}` });
    }

    this.setState({
      selectedRowKeys,
      canEditClassify: ncmNaoEncontrada ? ncmNaoEncontrada : canEditClassify,
    });
  };

  handleDropdownNcm = (value) => {
    const vazio = value === "Vazio" ? true : false;
    this.setState({
      dropdown: {
        ...this.state.dropdown,
        vazioNcm: vazio,
      },
      filter: {
        ...this.state.filter,
        sNcm: vazio ? null : this.state.filter.sNcm,
      },
    });
  };

  handleDropdownCest = (value) => {
    const vazio = value === "Vazio" ? true : false;
    this.setState({
      dropdown: {
        ...this.state.dropdown,
        vazioCest: vazio,
      },
      filter: {
        ...this.state.filter,
        sCest: vazio ? null : this.state.filter.sCest,
      },
    });
  };

  handleDropdownEX = (value) => {
    const vazio = value === "Vazio" ? true : false;
    this.setState({
      dropdown: {
        ...this.state.dropdown,
        vazioEX: vazio,
      },
      filter: {
        ...this.state.filter,
        sEx: vazio ? null : this.state.filter.sEx,
      },
    });
  };

  handleFilters = async (afterDeleteProduct = false) => {
    const { filter, isDuplicated, sizePage, extraData } = this.state;
    let newFilter = { ...filter };
    let filterStr = "";

    await this.setState({
      visibleModal: false,
      visibleEdit: false,
      visibleDelete: false,
      visibleClassify: false,
      isEdit: false,
      selectedAll: false,
      selectedRowKeys: [],
    });

    if (newFilter.sNcm === "") {
      newFilter = {
        ...newFilter,
        sNcm: null,
      };
    }

    const { dropdown } = this.state;

    Object.keys(newFilter).map((item) => {
      if (newFilter[item]) {
        const separador = filterStr ? "|" : "";
        if (item === "sCest") {
          const cest = filter[item];
          filterStr =
            cest !== "=" && !dropdown.vazioCest
              ? filterStr + separador + item + cest
              : filterStr;
          filterStr = dropdown.vazioCest
            ? filterStr + separador + item + "="
            : filterStr;
        } else if (item === "sNcm") {
          const ncm = filter[item];
          filterStr =
            ncm !== "=" && !dropdown.vazioNcm
              ? filterStr + separador + item + ncm
              : filterStr;
          filterStr = dropdown.vazioNcm
            ? filterStr + separador + item + "="
            : filterStr;
        } else if (item === "sEx") {
          const ex = filter[item];
          filterStr =
            ex !== "=" && !dropdown.vazioEX
              ? filterStr + separador + item + ex
              : filterStr;
          filterStr = dropdown.vazioEX
            ? filterStr + separador + item + "="
            : filterStr;
        } else {
          filterStr =
            newFilter[item] !== "="
              ? filterStr + separador + item + newFilter[item]
              : filterStr;
        }
      } else {
        if (
          (item === "sCest" && dropdown.vazioCest) ||
          (item === "sNcm" && dropdown.vazioNcm) ||
          (item === "sEx" && dropdown.vazioEX)
        ) {
          filterStr = filterStr
            ? filterStr + "|" + item + "="
            : filterStr + item + "=";
        }
      }
      filterStr = filterStr.replace("sorter", "");
      return filterStr;
    });

    this.setState(
      {
        filterStr: filterStr,
        paginationStr: `?pageNumber=1&pageSize=${sizePage}&filter=`,
      },
      () => {
        filterStr = this.state.paginationStr + filterStr;        
        this.props.getProducts(filterStr, extraData, isDuplicated);
        if(afterDeleteProduct) this.props.getProductsPisCofins(filterStr, extraData, isDuplicated);
      }
    );

    this.setState({ filter: newFilter });
  };

  handleChangeSorter = (pagination, filters, sorter) => {
    const order = sorter.order === "ascend" ? 0 : 1;

    this.setState(
      {
        filter: {
          ...this.state.filter,
          sorter: sorter.field ? "o" + sorter.field + "=" + order : "",
        },
      },
      () => {
        this.handleFilters();
      }
    );
  };

  handleChangeField = (e, field) => {
    let value, name;

    if (e === "Periodo") {
      value = dateToEnglish(field);
      name = e;

      if (!value) {
        this.setState((state) => ({
          selectedCurrent: null,
          filter: {
            ...state.filter,
            sBaseClassificacaoUsuario: 0,
          },
        }));
      } else {
        this.setState((state) => ({
          selectedBaseNcm: null,
          filter: {
            ...state.filter,
            sBaseNcm: 0,
          },
        }));
      }
    } else {
      value = field ? e : e.target.value;
      name = field ? field : e.target.name;

      if (name === "Ncm") {
        value = value.split(".").join("");
      }
    }

    this.setState((state) => ({
      filter: {
        ...state.filter,
        ["s" + name]: value !== null ? `=${value}` : null,
      },
    }));

    if (field === "BaseNcm") {
      this.setState({ selectedBaseNcm: value });
    } else if (field === "ClassificacaoFinal") {
      this.setState({ selectedClassified: value });
    } else if (field === "BaseClassificacaoUsuario") {
      this.setState({ selectedCurrent: value });
    }
  };

  handleClickFilter = (e) => {
    const id = e.target.id,
      value = e.target.value;

    if (id === "sDuplicado" && value === "=1") {
      this.setState((prevState) => ({
        filter: {
          ...prevState.filter,
          sClassificado: null,
        },
        isDuplicated: true,
      }));
    } else {
      this.setState((prevState) => ({
        filter: {
          ...prevState.filter,
          sDuplicado: null,
        },
        isDuplicated: false,
      }));
    }

    this.setState(
      (prevState) => ({
        filter: {
          ...prevState.filter,
          [id]: value,
        },
      }),
      () => this.handleFilters()
    );
  };

  handleClickExport = () => {
    const { filterStr, selectedAll, selectedRowKeys, extraData } = this.state;
    let data = {};

    if (!selectedAll) {
      data.Ids = selectedRowKeys;
      this.props.exportarProdutos(data, `?filter=${filterStr}`, extraData);
    } else {
      this.props.exportarProdutos(
        data,
        filterStr ? `?filter=${filterStr}&todos=true` : "?todos=true",
        extraData
      );
    }
    this.handleReset();
  };

  handleClickExport = () => {
    const { filterStr, selectedAll, selectedRowKeys, extraData } = this.state;
    let data = {};

    if (!selectedAll) {
      this.setState({ isExport: true });
      data.Ids = selectedRowKeys;
      this.props.exportarProdutos(data, `?filter=${filterStr}`, extraData);
    } else {
      this.setState({ isExport: true });
      this.props.exportarProdutos(
        data,
        filterStr ? `?filter=${filterStr}&todos=true` : "?todos=true",
        extraData
      );
    }

    this.setState({ isExport: false });
  };

  onSelect = (selectedAll) => {
    const { productsIcms, paging } = this.props;
    const { useData, sizePage } = this.state;
    const { sNcm, sCest } = this.state.filter;
    const { cnpj } = this.props.match.params;
    let ncmNaoEncontrada = false;
    let canEditClassify = false;
    let itemFilter = "";
    let ncm = "";
    let cest = "";

    if (paging.TotalItems <= sizePage) {
      ncmNaoEncontrada = _.every(useData, {
        DescricaoTributacaoIcms: "NCM NÃO ENCONTRADA",
      });

      if (!ncmNaoEncontrada && useData.length) {
        canEditClassify = _.every(useData, {
          Ncm: useData[0].Ncm,
          Cest: useData[0].Cest,
        });
      }
    }

    if (!selectedAll) {
      this.setState((prevState) => ({
        selectedRowKeys: !prevState.selectedAll
          ? productsIcms && productsIcms.map((item) => item.Id)
          : [...Array(0).keys()],
        selectedAll: !prevState.selectedAll,
      }));
    } else {
      this.setState({
        selectedRowKeys: productsIcms && productsIcms.map((item) => item.Id),
      });
    }

    if (sNcm !== "" && sCest !== "") {
      if (sNcm) ncm = sNcm.replace("=", "");
      if (sCest) cest = sCest.replace("=", "");
      itemFilter = `Ncm=${ncm}&Cest=${cest}&Cnpj=${cnpj}`;
    }

    this.setState({
      canEditClassify: ncmNaoEncontrada ? ncmNaoEncontrada : canEditClassify,
      itemFilter,
    });
  };

  onSelectRow = (record, selected, selectedRows) => {
    const endClassify = record.ClassificacaoIcms.length > 0 ? true : false;

    if (selectedRows.length === 1) {
      if (endClassify) {
        this.setState({
          editClassify: true,
          listPeriod: selectedRows[0].ClassificacaoIcms,
        });
      } else {
        this.setState({
          listPeriod: [],
        });
      }
      this.setState({
        isRevenue: selectedRows[0].ConsiderarReceita,
      });
    } else {
      this.setState({
        editClassify: false,
        listPeriod: [],
        isRevenue: !selectedRows.every((item) => !item.ConsiderarReceita),
      });
    }
  };

  showDrawer = (name) => {
    const { canEditClassify } = this.state;

    if (name === "visibleDrawerClassify") {
      if (canEditClassify) {
        this.setState({ [name]: true });
      } else {
        Modal.warning({
          content:
            "Só é possível classificar vários produtos que contenham a mesma NCM e/ou CEST. A classificação deverá ser realizada por página. Por favor selecione produtos com a mesma NCM e/ou CEST e repita o procedimento.",
        });
      }
    } else {
      this.setState({ [name]: true });
    }
  };

  onClose = (name, clear) => {
    this.setState((state) => ({
      [name]: false,
      selectedAll: false,
      selectedRowKeys: clear ? [] : state.selectedRowKeys,
      editClassify: false,
      listPeriod: [],
      itemFilter: "",
    }));
  };

  exitEditDivergence = () => {
    this.setState(
      {
        extraData: {
          month: null,
          year: null,
          status: null,
        },
      },
      () => this.props.getProducts()
    );
  };

  renderButtonDivergence = () => {
    const { statusError } = this.props;
    if (statusError) {
      switch (statusError) {
        case 4:
          return (
            <Button
              className="btn-divergence"
              type="danger"
              onClick={this.exitEditDivergence}
            >
              Sair da edição de duplicidade
            </Button>
          );
        default:
          return (
            <Button
              className="btn-divergence"
              type="danger"
              onClick={this.exitEditDivergence}
            >
              Sair da edição de pendência
            </Button>
          );
      }
    }
    return null;
  };

  handlerEnabledComponent = (condition, view) => {
    if (condition) {
      return view;
    }
    return null;
  };

  openEConsulta = (ncm, tc) => {
    let uf = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Uf;
    // Existe um cenário ainda não descoberto em que a UF não está indo a URL para abrir o eConsulta,
    // logo tentamos mais de uma vez buscar a UF da sessionStore
    if (!uf) {
      uf = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Uf;
    }

    /**
     * Devido ao erro abordado acima, agregamos na URL uma outra variável no fim da URL verificar se o Browser está
     * desconsiderando o último parâmetro ou se realmente é um problema da leitura da UF na SessionStore
     */
    if (tc === "NCM POSSUI POSSIBILIDADE DE SER ICMS PRÓPRIO E ICMS ST") {
      window.open(
        `https://econsulta.e-auditoria.com.br/Home/ConsultaRecuperador?id=${ncm}&tc=ICMS-interno&uf=${uf}&request=${Math.random()}`
      );
      window.open(
        `https://econsulta.e-auditoria.com.br/Home/ConsultaRecuperador?id=${ncm}&tc=ICMS-ST&uf=${uf}&request=${Math.random()}`
      );
    } else if (tc === "ICMS PRÓPRIO") {
      window.open(
        `https://econsulta.e-auditoria.com.br/Home/ConsultaRecuperador?id=${ncm}&tc=ICMS-interno&uf=${uf}&request=${Math.random()}`
      );
    } else if (
      tc === "ICMS ST" ||
      tc === "CEST NÃO VIGENTE" ||
      tc === "CEST INVÁLIDA PARA ESTA NCM NO ESTADO"
    ) {
      window.open(
        `https://econsulta.e-auditoria.com.br/Home/ConsultaRecuperador?id=${ncm}&tc=ICMS-ST&uf=${uf}&request=${Math.random()}`
      );
    } else if (tc === "NCM NÃO VIGENTE") {
      window.open(
        `https://econsulta.e-auditoria.com.br/Home/ConsultaRecuperador?id=${ncm}&request=${Math.random()}`
      );
    }
  };

  showDeleteConfirm() {
    confirm({
      title: 'ATENÇÃO',
      icon: <ExclamationCircleOutlined />,
      content: 'A exclusão de um ou mais itens, após o processamento dos cálculos, poderá interferir nos resultados gerados, caso esse(s) item(s) tenha(m) sido movimentados em suas saídas. Tem certeza que deseja prosseguir? ',
      okText: 'Sim',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: () => {
        this.deleteProduct();
      },
      onCancel() { },
    });
  }

  renderButtonExport(sBaseNcm) {
    const { isProcessando } = this.props;
    const { filter, isExport } = this.state;

    if (sBaseNcm !== "=1" && sBaseNcm !== "=2" && filter.sPeriodo === null) {
      return (
        <Popconfirm
          title="Exportar itens para revisão?"
          okText="Sim"
          cancelText="Não"
          onConfirm={this.handleClickExport}
        >
          <Tooltip
            placement="bottom"
            title={
              isProcessando
                ? "Funcionalidade desabilitada por ter documentos em processamento"
                : "Exporta todos os itens para que seja feita a revisão de códigos NCM. Ao final, você poderá importar essa planilha novamente para o sistema e atualizar seu cadastro."
            }
          >
            <Button
              className="ml-1"
              type="primary"
              loading={isExport}
              disabled={isProcessando}
              ghost
            >
              Exportar itens para revisão de NCM
            </Button>
          </Tooltip>
        </Popconfirm>
      );
    } else {
      return null;
    }
  }

  render() {
    const {
      product,
      productsIcms,
      paging,
      total,
      statusError,
      isFetching,
      isProcessando,
    } = this.props;
    const {
      sizePage,
      filter,
      visibleModal,
      visibleEdit,
      visibleDelete,
      visibleClassify,
      isEdit,
      selectedAll,
      selectedRowKeys,
      visibleDrawerFilter,
      visibleDrawerClassify,
      editClassify,
      filterStr,
      listPeriod,
      itemFilter,
      isRevenue,
      useData,
    } = this.state;

    const columns = [
      {
        title: "Código do Item",
        dataIndex: "CodigoProduto",
        width: 150,
        sorter: true,
      },
      {
        title: "Descrição",
        dataIndex: "Descricao",
        sorter: true,
      },
      {
        title: "NCM",
        dataIndex: "Ncm",
        width: 80,
        sorter: true,
        render: (text, record) => maskNcm(record.Ncm),
      },
      {
        title: "EX",
        dataIndex: "Ex",
        width: 60,
        align: "center",
        sorter: true,
      },
      {
        title: "CEST",
        dataIndex: "Cest",
        width: 80,
        sorter: true,
        render: (text, record) => maskCest(record.Cest),
      },
      {
        title: "EAN",
        dataIndex: "Ean",
        width: 120,
        sorter: true,
      },
      {
        title: (
          <img
            style={{ height: "16px" }}
            src="https://images.e-auditoria.com.br/global/logos/svg/econsulta-white.svg"
            alt="e-Consulta"
          />
        ),
        dataIndex: "DescricaoTributoNcm",
        width: 230,
        render: (text, record) => (
          <>
            <i
              className={`fas fa-search btn-econsulta ${record.DescricaoTributacaoIcms === "NCM NÃO ENCONTRADA" ||
                record.DescricaoTributacaoIcms === "-"
                ? "invisible"
                : "visible"
                }`}
              onClick={() =>
                this.openEConsulta(record.Ncm, record.DescricaoTributacaoIcms)
              }
            />
            {record.DescricaoTributacaoIcms}
          </>
        ),
      },
      {
        title: "Trib. Considerada",
        dataIndex: "Classificacao",
        width: 150,
        align: "center",
        render: (text, record) => {
          let classificacaoVigente = record.ClassificacaoIcms.filter(
            (c) => c.Vigente
          );
          if (classificacaoVigente[0]) {
            return <>{classificacaoVigente[0].DescricaoTributacao}</>;
          }
          return "-";
        },
      },
    ];

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      hideDefaultSelections: true,
      selections: [
        {
          key: "all-data",
          text: "Selecionar todos",
          onSelect: () => this.onSelect(),
        },
      ],
      onSelect: this.onSelectRow,
      getCheckboxProps: () => ({
        disabled: selectedAll,
      }),
      onSelectAll: this.onSelectAll,
      fixed: true,
      columnWidth: 50,
    };

    return (
      <>
        {isFetching ? <Loading text="Carregando produtos" /> : null}

        {visibleModal ? (
          <ModalProduct
            visible={visibleModal}
            visibleModal={this.visibleModal}
            handleFilters={this.handleFilters}
            product={product}
            isEdit={isEdit}
            changePage={(page) => this.setState({ pageNumber: page })}
          />
        ) : null}

        {visibleDrawerFilter ? (
          <DrawerFilter
            {...this.state}
            visibleDrawer={visibleDrawerFilter}
            handleChangeField={this.handleChangeField}
            handleFilters={this.handleFilters}
            handleReset={this.handleReset}
            onClose={this.onClose}
            handleDropdownCest={this.handleDropdownCest}
            handleDropdownNcm={this.handleDropdownNcm}
            handleDropdownEX={this.handleDropdownEX}
          />
        ) : null}

        {visibleDrawerClassify ? (
          <DrawerClassify
            {...this.state}
            visibleDrawer={visibleDrawerClassify}
            listPeriod={listPeriod}
            itemFilter={itemFilter}
            isRevenue={isRevenue}
            handleReset={this.handleReset}
            onClose={this.onClose}
          />
        ) : null}

        {productsIcms?.length ? (
          <>
            {this.handlerEnabledComponent(
              (total && total.FiltroDuplicados) ||
              (statusError && statusError > 0),
              <Alert
                className="mb-2"
                showIcon={true}
                message="A edição do item não irá alterar os resultados já gerados. Caso queira que a edição do item modifique os resultados anteriores ou posteriores, você terá que reprocessar as competências desejadas."
                type="warning"
              />
            )}
            <div className="products__actions">
              <div className="products__actions___filters">
                {visibleClassify ? (
                  <span className="mt-1 mr-2">
                    {`${selectedAll ? paging.TotalItems : selectedRowKeys.length
                      } selecionado(s)`}
                  </span>
                ) : null}

                {this.handlerEnabledComponent(
                  statusError !== 3 &&
                  statusError !== 4 &&
                  statusError !== 5 &&
                  statusError !== 6,
                  <>
                    <Button
                      className={
                        filter.sClassificado === "=0"
                          ? "btn btn--active"
                          : "btn"
                      }
                      id="sClassificado"
                      value="=0"
                      disabled={total && !total.NaoClassificado}
                      onClick={this.handleClickFilter}
                    >
                      {total && total.NaoClassificado + " não classificados"}
                    </Button>
                  </>
                )}

                {this.handlerEnabledComponent(
                  statusError !== 3 &&
                  statusError !== 4 &&
                  statusError !== 5 &&
                  statusError !== 6,
                  <>
                    <Button
                      className={
                        filter.sClassificado === "=1"
                          ? "btn btn--active"
                          : "btn"
                      }
                      id="sClassificado"
                      value="=1"
                      disabled={total && !total.Classificados}
                      onClick={this.handleClickFilter}
                    >
                      {total && total.Classificados + " classificados"}
                    </Button>
                  </>
                )}

                {this.handlerEnabledComponent(
                  statusError !== 3 &&
                  statusError !== 4 &&
                  statusError !== 5 &&
                  statusError !== 6,
                  <>
                    {total && total.ItensDuplicados ? (
                      <Button
                        className={
                          filter.sDuplicado === "=1" ? "btn btn--active" : "btn"
                        }
                        id="sDuplicado"
                        value="=1"
                        disabled={total && !total.ItensDuplicados}
                        onClick={this.handleClickFilter}
                      >
                        {total && total.ItensDuplicados + " itens duplicados"}
                      </Button>
                    ) : null}
                  </>
                )}

                {(total && total.FiltroDuplicados) ||
                  (statusError && statusError > 0)
                  ? null
                  : this.renderButtonExport(this.state.filter.sBaseNcm)}

                {visibleEdit ? (
                  <Tooltip title="Editar produto">
                    <Button
                      className="btn"
                      icon="edit"
                      loading={isFetching || isProcessando}
                      onClick={() => this.visibleModal(true)}
                    />
                  </Tooltip>
                ) : null}

                {visibleDelete ? (
                  <Button className="btn btn-hover-danger" icon="delete" disabled={isFetching || isProcessando} onClick={() => this.showDeleteConfirm()} />
                ) : null}
              </div>
              <div>
                {visibleClassify ? (
                  <>
                    <Popconfirm
                      title="Confirmar classificação pela indicação do e-Consulta?"
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={this.classifySuggestion}
                      disabled={isFetching || isProcessando}
                    >
                      <Button className="btn" type="primary" ghost>
                        Classificar conforme e-Consulta
                      </Button>
                    </Popconfirm>

                    <Button
                      className="btn"
                      type="primary"
                      ghost
                      onClick={() => this.showDrawer("visibleDrawerClassify")}
                      disabled={isFetching || isProcessando}
                    >
                      {!editClassify
                        ? "Classificar manualmente"
                        : "Editar classificação"}
                    </Button>
                  </>
                ) : null}

                <Tooltip title="Filtrar">
                  <Button
                    className="btn"
                    icon="filter"
                    onClick={() => this.showDrawer("visibleDrawerFilter")}
                  />
                </Tooltip>

                {this.renderButtonDivergence()}

                {total && total.FiltroDuplicados ? (
                  <Button
                    className="btn-divergence"
                    type="danger"
                    onClick={() => this.props.getProducts()}
                  >
                    Sair da edição de duplicidade
                  </Button>
                ) : null}
              </div>
            </div>

            <Table
              className="ant-table--custom noselect"
              dataSource={useData}
              rowKey={(record) => record.Id}
              columns={columns}
              scroll={{
                x: 1100,
                y:
                  (total && total.FiltroDuplicados) || statusError > 0
                    ? "calc(100vh - 430px)"
                    : "calc(100vh - 360px)",
              }}
              pagination={false}
              rowSelection={rowSelection}
              onChange={this.handleChangeSorter}
              onSelectAll={this.handleSelectAll}
            />

            {paging ? (
              <Pagination
                className="pagination-classify mt-3"
                showSizeChanger
                pageSizeOptions={["10", "50", "100"]}
                current={this.state.pageNumber}
                defaultPageSize={sizePage}
                pageSize={sizePage}
                defaultCurrent={1}
                total={paging.TotalItems}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} de ${total} itens`
                }
                onChange={this.changePage}
                onShowSizeChange={this.changeSizePage}
              />
            ) : null}

            <Button
              className="btn-new-product"
              type="primary"
              shape="circle"
              icon="plus"
              size="large"
              onClick={() => this.visibleModal(false)}
              disabled={isFetching || isProcessando}
            />
          </>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nenhum produto para mostrar"
          >
            <Button
              className="btn-new-product"
              type="primary"
              shape="circle"
              icon="plus"
              size="large"
              onClick={() => this.visibleModal(false)}
              disabled={isFetching || isProcessando}
            />

            {filterStr !== "" ? (
              <Button
                className="btn"
                icon="filter"
                onClick={() => this.showDrawer("visibleDrawerFilter")}
              >
                Filtrar
              </Button>
            ) : null}
          </Empty>
        )}
      </>
    );
  }
}

const loadingGetProducts = createLoadingSelector(["GET_ICMS"]),
  loadingClassifyProduct = createLoadingSelector(["CLASSIFY_PRODUCT_ICMS"]),
  loadingClassifySuggestion = createLoadingSelector([
    "CLASSIFY_SUGGESTION_ICMS",
  ]),
  loadingPutClassify = createLoadingSelector(["PUT_CLASSIFY_ICMS"]),
  loadingDeleteProduct = createLoadingSelector(["DELETE_PRODUCT"]),
  loadingExportarProdutos = createLoadingSelector(["EXPORTAR_PRODUTOS"]);

const mapStateToProps = (state) => ({
  product: state.products.data.Retorno || {},
  productsIcms: state.icms.list,
  paging: state.icms.paging,
  total: state.icms.total,
  period: state.icms.period,
  statusError: state.icms.statusError,
  isProcessando: state.importacao.isProcessando,
  isFetching:
    loadingGetProducts(state) ||
    loadingClassifyProduct(state) ||
    loadingClassifySuggestion(state) ||
    loadingPutClassify(state) ||
    loadingDeleteProduct(state) ||
    loadingExportarProdutos(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getProduct,
      getProducts,
      getProductsPisCofins,
      deleteProduct,
      classifySuggestion,
      exportarProdutos,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(GridClassify));
